import React from 'react'
import styled from 'styled-components'

import Flex from '@jarvis.oddle/core/components/Flex'
import IconTriangle from '@jarvis.oddle/core/components/Icons/IconTriangle'
import { H4, P } from '@jarvis.oddle/core/components/Typo'
import Form from '@jarvis.oddle/core/components/Form'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

import useAppSelector from 'src/hooks/useAppSelector'
import { isObjectEmpty } from 'src/utils/object'
import useAppDispatch from 'src/hooks/useAppDispatcher'
import { fetchAvailableDateAction, fetchTimeslotAction } from 'src/redux/reservation'
import moment from 'moment/moment'

const StyledLabel = styled(P)`
  position: absolute;
  top: 0;
  font-weight: 400;
  font-size: 11px !important;
  line-height: 12px !important;
  color: #bbbbbb;
`

const StyledText = styled(H4)`
  margin: 21px 11px 8px 0;
  padding-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #000;
`

const StyledOption = styled.option`
  background: #F1F1F1;
`

const StyledTruncate = styled(Flex)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const OutletDropdown = (): JSX.Element => {
  const { t } = React.useContext(TranslationContext)
  const outlets = useAppSelector((state) => state['@reservation'].brandInfo?.data?.outlets) || []
  const dispatch = useAppDispatch()

  const onOutletChange = async ({ value, setFieldValue, values }) => {
    setFieldValue('outlet', value)

    await dispatch(fetchAvailableDateAction({
      outletId: value.id,
      pax: values.numberOfChildren + values.numberOfAdult,
      month: moment(new Date(values.date)).format('YYYY-MM')
    }))
    const newTimeslot = await dispatch(fetchTimeslotAction({
      outletId: value.id,
      pax: values.numberOfChildren + values.numberOfAdult,
      date: moment(new Date(values.date)).format('YYYY-MM-DD')
    }))
    if (newTimeslot?.payload?.[0]) {
      setFieldValue('slot', newTimeslot.payload[0], false)
    }
  }

  return (
    <Form.Select
      name='outlet'
      options={outlets}
      Icon={IconTriangle}
      labelFormatter={option => option.outletName}
      renderSelected={(option) => {
        if (isObjectEmpty(option)) {
          return (
            <Flex>
              <StyledText>
                {t('Select Location')}
              </StyledText>
            </Flex>
          )
        }
        return (
          <StyledTruncate>
            <StyledLabel>{t('Select Location')}</StyledLabel>
            <StyledText>
              {option.outletName}
            </StyledText>
          </StyledTruncate>
        )
      }}
      valueFormatter={(option) => option.id}
      CustomOption={StyledOption}
      onChange={onOutletChange}
    />
  )
}

export default OutletDropdown
